<div class="multiselect">
  <app-grouped-multiselect-search-menu
    *ngIf="optionGroup$ | async as optionGroup; else loadingSpecialty"
    [inputId]="inputId"
    [name]="name"
    [label]="label"
    [placeholder]="placeholder"
    [optionGroups]="optionGroup$ | async"
    [disabledGroup]="disabledGroup$ | async"
    [disabledLabel]="disabledLabel"
    [selectedOptions]="getSelectedOptions()"
    [isFullWidth]="false"
    (optionsSelected)="onOptionsChange($event)"
  >
  </app-grouped-multiselect-search-menu>

  <ng-template #loadingSpecialty>
    <app-grouped-multiselect-search-menu
      [inputId]="inputId"
      [name]="name"
      [label]="label"
      [placeholder]="placeholder"
      [isFullWidth]="false"
    >
    </app-grouped-multiselect-search-menu>
  </ng-template>
</div>
